import RecommendedReading from "./recommended_reading";

export default RecommendedReading;